import posthog from "posthog-js"

/*
 * PostHog (project BABYOOTD, US cloud): page views, clicks (autocapture) and
 * the events below. It goes through our own /ingest (worker/index.js) so ad
 * blockers don't drop it and the CSP stays 'self'.
 *
 * Kept in localStorage, no cookies. No emails are sent: someone on the
 * waitlist is identified by their waitlist code only.
 *
 * Events: waitlist_joined, spot_opened, share_clicked {channel},
 * friend_banner_shown, hero_mode_picked {mode}. Shared outfit, invite and gift
 * pages show up as page views with page_type outfit / invite / gift.
 */

// The project's public key: made to be in a web page.
const KEY = "phc_zUXjYMNLYyBu2UGS36pJEUuRDhRMPr9K4GKWrT33HQ2W"
const LOCAL = /^(localhost|127\.0\.0\.1|\[::1\])$/.test(location.hostname)

let started = false

export function startAnalytics() {
  // Local builds stay out of the numbers.
  if (started || LOCAL) return
  started = true
  posthog.init(KEY, {
    api_host: "/ingest",
    ui_host: "https://us.posthog.com",
    persistence: "localStorage",
    person_profiles: "identified_only",
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
    session_recording: { maskAllInputs: true },
  })
  // Which kind of page this is, on every event, for funnels by page type.
  const path = location.pathname
  posthog.register({
    page_type: path === "/" ? "home" : path.startsWith("/o/") ? "outfit" : path.startsWith("/join/") ? "invite" : path.startsWith("/r/") ? "gift" : path.startsWith("/sleep/") ? "bedtime_guide" : path.replace(/\//g, "") || "other",
    via_friend: new URLSearchParams(location.search).has("w"),
  })
}

export function track(event, props) {
  if (started) posthog.capture(event, props)
}

/** After joining: the person is their waitlist code, with their spot (never their email). */
export function identify(code, props) {
  if (started && code) posthog.identify(code, props)
}
